import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  INPUT_GROUP_TEXT_CLASS,
  TInputGroupTextProps,
} from "@/ui/components/form/InputGroup/InputGroup.config";

export const InputGroupText: FC<TInputGroupTextProps> = (
  {
    className,
    children,
    ...props
  },
) => (
  <span
    {...props}
    data-component="InputGroupText"
    className={cn(INPUT_GROUP_TEXT_CLASS, className)}
  >
    { children }
  </span>
);

InputGroupText.displayName = "InputGroupText";
